import { render } from "./servicevaluate.vue?vue&type=template&id=1750cdd0&scoped=true&ts=true"
import script from "./servicevaluate.vue?vue&type=script&lang=ts"
export * from "./servicevaluate.vue?vue&type=script&lang=ts"

import "./servicevaluate.vue?vue&type=style&index=0&id=1750cdd0&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1750cdd0"]])

export default __exports__